export default __webpack_public_path__ + "static/media/ad_logo.620cc4b6.png";